import 'whatwg-fetch'

import './theme'
import * as actions from './actions'
import * as components from './components'
import translations from '../translations'
import * as constants from './constants'
import * as utils from './utils'

export {
  useHelpTopic,
  useHelpPopup,
  useHelpContext
} from './components/HelpfulQuestionMark/hooks'

export {
  OlapRequest,
  OlapResponse,
  getTimezone,
  getDefaultCurrencyForRegionAndTimezone,
  insightsDateUtils,
  INSIGHTS_CONSTANTS
} from './components/InsightsWidgets'

export const {
  AccessDenied,
  Alert,
  AppIcon,
  CapabilitiesProvider,
  Column,
  DataProvider,
  DateRangePicker,
  DateRangePickerBUI,
  DateRangePickerPill,
  DelayedTooltip,
  Dialog,
  Error,
  GridContainer,
  GridOverlayHelper,
  MidSelector,
  MidSelectorMPUI,
  StoreSelector,
  MPGridColumn,
  MPGridGutter,
  MPGridHeader,
  MPGridRow,
  Pagination,
  RouterLink,
  Row,
  ResponsiveMenuButton,
  Root,
  VerticalRhythm,
  View,
  HelpPopup,
  NotificationBanners,
  withResponsive,
  withToggleProps,
  // FIXME: for easing migration, we should remove this (actually, we should remove all these, let clients go through the components object
  FeaturesProvider,
  withFeatures,
  OrientationContainer,
  OrientationProgressBar,
  OrientationTooltip,
  HelpArticleLink,
  AuthenticationRequired,
  AuthenticationContextProvider,
  useAuthenticationContext,
  SupportButton
} = components

export {
  actions,
  components,
  constants,
  translations,
  utils
}
